import { useTranslation } from 'react-i18next';

import { useCutlistState } from '@/api/store';
import { Icon, Info } from '@/primitives/Icons';

import Card from './Card';
import styles from './DeliverLeftoverMaterial.module.css';

export const DeliverLeftoverMaterial = () => {
  const { t } = useTranslation();
  const cutlistStore = useCutlistState();

  return (
    <Card className={styles.container}>
      <label className="flexAlign stack">
        <strong>{t('review.leftoverMaterials.title')}</strong>
        <div className="flexAlign">
          <input
            type="checkbox"
            name="deliverLeftoverMaterials"
            checked={cutlistStore.deliverLeftoverMaterials}
            onChange={(e) => {
              cutlistStore.setDeliverLeftoverMaterials(e.target.checked);
            }}
          />
          {t('review.deliverLeftover.title')}
        </div>
        {cutlistStore.deliverLeftoverMaterials && (
          <p className="flexAlign gap-xs">
            <Icon icon={<Info />} className="noShrink" size={2} />
            {t('review.leftoverMaterials.disclaimer')}
          </p>
        )}
      </label>
    </Card>
  );
};
